/* eslint-disable */
import Vue from 'vue'
import { authHeader, handleResponse } from '../_helpers';

function getSiteInfo() {

    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', ...authHeader() }
    };    

    return fetch(`${Vue.appConfig.apiBaseUrl}/praktijk/siteinfo`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response.data;
        });
}

export const appService = {
    getSiteInfo: getSiteInfo
};